/* eslint-disable react/jsx-boolean-value */
import React, { useState, useEffect, useContext } from 'react';
import './header-sidebar.css';
// import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import SearchInput from '../searchInput/SearchInput';
import { PrivilegeContext } from '../../config/reducer/Privilege';
// import Navigation from '../navigation/Navigation';
import HeaderImage from '../../image/header.svg';
import AMLogo from '../../image/AM.png';
import ByLogo from '../../image/byLogo.svg';
import ListNavigationSidebar from '../navigation/ListNavigationSidebar';
import { useApiData } from '../../config/reducer/Modules';
import { FLEET_AI_ENABLED } from '../../config/featureFlags';

export default function HeaderSideBar(props, { history }) {
    const {
        navigationState, setNavigationState, isAdmin, setNavigationClick,
    } = props;

    const isDefault = useMediaQuery({
        query: '(min-width: 1024px)',
    });
    const isMobileOrTablet = useMediaQuery({
        query: '(max-width: 1023px)',
    });

    const navigate = useNavigate();
    const { apiResponse } = useApiData();
    const [liveState, setLiveState] = useState(true);
    const [insightState, setInsightState] = useState(true);
    const [inventoryState, setInventoryState] = useState(true);
    const [analyticsState, setAnalyticsState] = useState(true);

    // const checkLiveEnabled = !((apiResponse?.module?.live?.liveMap === false) && (apiResponse?.module?.live?.telemetrySnapshot === false) && (apiResponse?.module?.live?.assetStatus === false));
    // const checkInsightsEnabled = !((apiResponse?.module?.insights?.assetPerformance === false));
    // const checkInventoryEnabled = !((apiResponse?.module?.fleetManagement?.asset === false) && (apiResponse?.module?.fleetManagement?.beacon === false) && (apiResponse?.module?.fleetManagement?.geofence === false));

    const headerNavigationList = [
        {
            text: 'Dashboard', value: 'dashboard', path: '/dashboard', enabled: true,
        },
        {
            text: 'Live', value: 'mapOverview', path: '/live/mapOverview', enabled: (apiResponse?.role === 'Agency Administrator' || apiResponse?.role === 'Agency Owner') ? true : liveState,
        },
        {
            text: 'Insights', value: 'insights', path: '/insights/assetPerformance', enabled: (apiResponse?.role === 'Agency Administrator' || apiResponse?.role === 'Agency Owner') ? true : insightState,
        },
        {
            text: 'Inventory', value: 'inventory', path: '/inventory/assetdevices', enabled: (apiResponse?.role === 'Agency Administrator' || apiResponse?.role === 'Agency Owner') ? true : inventoryState,
        },
        {
            text: 'Fleet AI', value: 'fleetAI', path: '/fleet', enabled: FLEET_AI_ENABLED,
        },
        {
            text: 'Analytics', value: 'analytics', path: '/analytics', enabled: (apiResponse?.role === 'Agency Administrator' || apiResponse?.role === 'Agency Owner') ? true : analyticsState,
        },
    ];

    const headerNavigationListAdmin = [
        {
            text: 'Dashboard', value: 'dashboard', path: '/dashboard', enabled: true,
        },
        // {
        //     text: 'Live', value: 'mapOverview', path: '/live/mapOverview', enabled: true,
        // },
        // {
        //     text: 'Insights', value: 'insights', path: '/insights/assetPerformance', enabled: true,
        // },
        {
            text: 'Inventory', value: 'inventory', path: '/inventory/assetdevices', enabled: true,
        },
        {
            text: 'Agencies', value: 'agencies', path: '/agencies', enabled: true,
        },
    ];

    useEffect(() => {
        if ((apiResponse?.module?.live === undefined)) {
            setLiveState(false);
        }
        if ((apiResponse?.module?.insights === undefined)) {
            setInsightState(false);
        }

        if ((apiResponse?.module?.fleetManagement === undefined)) {
            setInventoryState(false);
        }
        if ((apiResponse?.module?.live?.liveMap === false) && (apiResponse?.module?.live?.telemetrySnapshot === false) && (apiResponse?.module?.live?.assetStatus === false)) {
            setLiveState(false);
        }
        if ((apiResponse?.module?.live?.liveMap === false) && (apiResponse?.module?.live?.telemetrySnapshot === false) && (apiResponse?.module?.live?.assetStatus === true)) {
            setLiveState(false);
        }
        if ((apiResponse?.module?.insights?.assetPerformance === false) && (apiResponse?.module?.insights?.iorail === false) && (apiResponse?.module?.insights?.ioroad === false) && (apiResponse?.module?.insights?.odAnalytics === false)) {
            setInsightState(false);
        }
        if ((apiResponse?.module?.insights?.assetPerformance === false) && (apiResponse?.module?.insights?.odAnalytics === false) && ((apiResponse?.module?.insights?.iorail === true) || (apiResponse?.module?.insights?.ioroad === true))) {
            setInsightState(false);
        }
        if ((apiResponse?.module?.fleetManagement?.asset === false) && (apiResponse?.module?.fleetManagement?.beacon === false) && (apiResponse?.module?.fleetManagement?.geofence === false)) {
            setInventoryState(false);
        }
        setAnalyticsState(
            apiResponse?.module?.analytics?.fleetDashboard === true
            || apiResponse?.module?.analytics?.analyticsDashboard === true
            || apiResponse?.module?.analytics?.batteryDashboard === true,
        );
    }, [apiResponse]);
    return (
        <div className="header-container-main">
            <div className="header-image-container">
                {/* Horizon Logo */}
                <div className="logo-container">
                    <img loading="lazy" src={HeaderImage} className="logo" alt="header-logo" />
                </div>
                {/* Asia Mobiliti Logo */}
                <div className="logo-container-alt">
                    <img loading="lazy" src={AMLogo} className="logo-alt" alt="header-logo" />
                </div>
            </div>
            <div className="search-sidebar-header">
                {/* <SearchInput containerWidth="12.75rem" text="Search" containerHeight="22px" /> */}
            </div>
            <div className="main-nav-container">
                <div className="header-nav">
                    <ListNavigationSidebar
                      list={isAdmin ? headerNavigationListAdmin : headerNavigationList}
                      navigationState={navigationState}
                      setNavigationState={setNavigationState}
                      setNavigationClick={setNavigationClick}
                    />
                </div>
                {/* {isAdmin ? (
                <ListNavigationSidebar list={headerNavigationListAdmin} navigationState={navigationState} setNavigationState={setNavigationState} setNavigationClick={setNavigationClick} />) : (
                <ListNavigationSidebar list={headerNavigationList} navigationState={navigationState} setNavigationState={setNavigationState} setNavigationClick={setNavigationClick} />)} */}
            </div>
        </div>
    );
}
